import styled, {keyframes} from 'styled-components';

export const PlayerContainer = styled.div<{$isVisible: boolean}>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: #000;
    z-index: 9999;
    display: ${({$isVisible}) => ($isVisible ? 'flex' : 'none')};
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const VideoContainer = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const PlayerWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`;

export const ProgressBar = styled.div`
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 4px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
    overflow: hidden;
`;

export const Progress = styled.div<{$progress: number}>`
    height: 100%;
    background-color: #ff0000;
    width: ${({$progress}) => $progress}%;
    transition: width 0.1s ease;
`;

export const TimeDisplay = styled.div`
    position: absolute;
    bottom: 90px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    font-size: 14px;
    font-weight: 500;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 4px 8px;
    border-radius: 4px;
`;

const LayoutButtonSlideUp = keyframes`
    from {
        transform: translate(-50%, 0%);
        visibility: hidden;
        opacity: 0;
    }
    to {
        transform: translate(-50%, -50%);
        visibility: visible;
        opacity: 1;
    }
`;

const LayoutButtonSlideDown = keyframes`
    from {
        transform: translate(-50%, -50%);
        visibility: visible;
        opacity: 1;
    }
    to {
        transform: translate(-50%, 0%);
        visibility: hidden;
        opacity: 0;
    }
`;

export const LayoutButton = styled.div<{$visible: boolean}>`
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem;
    border-radius: 1rem;
    animation: ${({$visible}) => ($visible ? LayoutButtonSlideUp : LayoutButtonSlideDown)} 0.5s forwards;
`;

export const LayoutItem = styled.div<{$focused: boolean}>`
    display: flex;
    border: ${({$focused}) => ($focused ? '5px solid white' : 'none')};
    border-radius: 50%;
    margin: 1vw;
    background-color: ${({$focused}) => ($focused ? 'rgba(255, 255, 255, 0.2)' : '#000')};
    color: ${({$focused}) => ($focused ? '#fff' : '#000')};
`;

export const CloseButton = styled.button<{$focused: boolean}>`
    position: absolute;
    top: 20px;
    left: 20px;
    background-color: ${({$focused}) => ($focused ? '#fff' : 'rgba(255, 255, 255, 0.2)')};
    color: ${({$focused}) => ($focused ? '#000' : '#fff')};
    border: none;
    border-radius: 10px;
    width: 300px;
    height: 80px;
    font-size: 30px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${({$focused}) => ($focused ? 1 : 0.8)};

    &:hover {
        background-color: ${({$focused}) => ($focused ? '#fff' : 'rgba(255, 255, 255, 0.3)')};
    }
`;
